// import { isElement } from 'react-dom/test-utils';
// import { isServer } from 'src/utils/common';
// import ZeeVideoJSPlayer from './src/ZeeVideosJsPlayer';
import { getLocalStorage, getCookie } from '../../utils/browserStorageHandler';
import { XACCESS_AUTHORIZATION_COOKIE } from '../../utils/constants/cookieConstants';
import {
  USER_TOKEN,
  GUEST_TOKEN,
  USER_TYPE
} from '../../utils/constants/localStorageConstants';

// const isServer = false;
let isServerPlayer = false;
const token = !isServerPlayer ? getLocalStorage(USER_TOKEN) : '';
const guestToken = !isServerPlayer ? getLocalStorage(GUEST_TOKEN) : '';
const accessToken = !isServerPlayer
  ? getCookie(XACCESS_AUTHORIZATION_COOKIE)
  : '';
const userType = !isServerPlayer
  ? getLocalStorage(USER_TYPE) || 'guest'
  : 'guest';

/* Default player config */
const playerConfig = {
  // contentId: contentId,
  token,
  guestToken,
  accessToken,
  userType,
  videoTagId: 'video-tag'
  // spapiData: ''
};
// eslint-disable-next-line
let videoJsPlayer;
// // // //  ** IMPORTANT ** this is for developement only, do not check in. Umcomment ZeeVideoJSPlayer import above to use.
// videoJsPlayer = new ZeeVideoJSPlayer(playerConfig);

// eslint-disable-next-line
videoJsPlayer = !isServerPlayer
  ? new window.webPlayer.default(playerConfig)
  : {};
export default videoJsPlayer;
